import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { PremiumAdminFeaturesPageLoader } from '@confluence/experiment-confluence-administration-upsell/entry-points/ui/PremiumAdminFeaturesPage';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

export const PremiumAdminFeaturesRoute = () => <PremiumAdminFeaturesPageLoader />;

PremiumAdminFeaturesRoute.NAVIGATION_PARAMS = () => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { edition } = useSessionData();
	return {
		Screen: {
			screenEvent: { name: 'premiumAdminFeaturesScreen', attributes: { edition } },
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
